import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/:Uid/:ShareId',
            name: 'Square',
            component: resolve => require(['@/components/Square'], resolve)
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js